import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import { invokeApi } from "../../../bl_libs/ApiCalling";
import { withRouter } from "react-router-dom";
import { FormControl, IconButton, InputLabel, Select } from "@material-ui/core";
import { CKEditor } from "../../../components";
const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: "#c4314b",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  txt: {
    color: "black",
  },
  alert: {
    width: "100%",
  },
  swtch: {
    marginTop: "20px",
  },
}));

function AddPlan(props) {
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState(false);

  const [inputs, setInputs] = useState({
    title: "",
    amount: "",
    duration: "",
    detail: "",
    status: true,
  });

  const [feature, setFeatures] = useState([
    {
      property: "You can use market place",
      value: true,
    },
    {
      property: "Place bids on move requests",
      value: false,
    },
    {
      property: "Start move request with clients",
      value: true,
    },
    {
      property: "Transfer money to a bank account",
      value: true,
    },
    {
      property: "You can use CRM",
      value: true,
    },
  ]);

  const handleChange = (event) => {
    setInputs({
      ...inputs,
      [event.target.id]: event.target.value,
    });
  };

  const handleChangeInCkEditor = (key, value) => {
    setInputs({
      ...inputs,
      [key]: value,
    });
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    addPlan();
  };

  const addPlan = () => {
    setIsLoading(true);
    let Data = {
      title: inputs.title,
      amount: inputs.amount,
      duration: inputs.duration,
      detail: inputs.detail,
    };
    const token = localStorage.getItem("token");
    let requestObj = {
      path: "/api/admin/add_subscription_available",
      method: "POST",
      postData: Data,
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      //console.log(res, "RESPONSE");
      if (res.code == 200) {
        handleBack();
      } else {
        setErrorMessage(res.message);
        setIsLoading(false);
      }
    });
  };
  const handleBack = () => {
    props.history.goBack();
  };

  if (isLoading) {
    return (
      <div className="Circular-Progress">
        <CircularProgress color="primary" />
      </div>
    );
  }
  return (
    <>
      <Container component="main" maxWidth="sm">
        <IconButton
          className="backarrow pointer-point mt-2"
          onClick={handleBack}
          style={{ outline: "none" }}
        >
          <ArrowBackIcon color="primary"></ArrowBackIcon>
        </IconButton>
        <CssBaseline />
        <div className={classes.paper}>
          <Typography className={classes.txt} component="h1" variant="h5">
            Add Plan
          </Typography>
          {errorMessage && (
            <Alert className={classes.alert} severity="error">
              {errorMessage}
            </Alert>
          )}
          <form className={classes.form} onSubmit={handleSubmit}>
            <Grid container>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="title"
                  value={inputs.title}
                  onChange={handleChange}
                  label="Title"
                  autoFocus
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  type="number"
                  margin="normal"
                  required
                  fullWidth
                  id="amount"
                  value={inputs.amount}
                  onChange={handleChange}
                  label="Amount"
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl
                  size="medium"
                  variant="outlined"
                  className={classes.formControl + " mt-2 w-100"}
                >
                  <InputLabel htmlFor="duration">Duration *</InputLabel>
                  <Select
                    required
                    native
                    value={inputs.duration}
                    onChange={handleChange}
                    label="Duration *"
                    inputProps={{
                      name: "duration",
                      id: "duration",
                    }}
                  >
                    <option aria-label="None" value="" />
                    <option value="day">Daily</option>
                    <option value="month">Monthly</option>
                    <option value="year">Yearly</option>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography className="mt-2" color="textSecondary">
                  Details:
                </Typography>
                <CKEditor
                  content={inputs.detail}
                  setContent={(value) => {
                    handleChangeInCkEditor("detail", value);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Add Plan
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    </>
  );
}
export default withRouter(AddPlan);
